<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_CATEGORY_CREATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới danh mục thiết bị</h1>
      <div style="float: right">
        <button class="btn btn-light" @click="cancelModal = true">Hủy bỏ</button>
        <button @click="addCat" class="btn btn-success btn-primary ml-2">Thêm mới</button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: auto overflow-y: auto">
      <ValidationObserver ref="formAdd" class="card-body px-20">
        <form @submit.prevent="addCat" class="row">
          <div class="col-md-6">
            <h1 class="form-inner-heading mb-1">Thông tin</h1>
            <ValidationProvider rules="required" vid="type" name="Loại thiết bị">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Loại thiết bị <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="dataAdd.type" :options="optionsType"> </Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|minMaxName_3" vid="name" name="Tên đầy đủ">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Tên đầy đủ <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataAdd.name" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|minMaxName_3" vid="nickname" name="Tên rút gọn">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Tên rút gọn <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataAdd.nickname" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|minMaxName_3"
              vid="abbreviation"
              name="Tên viết tắt"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Tên viết tắt <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataAdd.abbreviation" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|regexNumber" vid="" name="Giá bán">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Giá bán (VNĐ) <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataAdd.price" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="unit" name="Đơn vị">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Đơn vị <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="dataAdd.unit" :options="optionUnit"> </Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="kind" name="Quản lý serial">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Quản lý serial <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="dataAdd.kind" :options="Config.checkSerial"> </Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="regexNumber" vid="warrantyPeriod" name="Thời hạn bảo hành">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label">Thời hạn bảo hành (tháng)</label>
                <div class="col-sm-8">
                  <input v-model.trim="dataAdd.warrantyPeriod" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="services" name="Dịch vụ sử dụng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label"
                  >Dịch vụ sử dụng <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <select2-multiple-control
                    v-model="dataAdd.services"
                    :options="optionService"
                  ></select2-multiple-control>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="maxReceipt_2" vid="description" name="Ghi chú">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-4 col-form-label">Ghi chú</label>
                <div class="col-sm-8">
                  <input v-model.trim="dataAdd.description" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="col-md-6">
            <h1 class="form-inner-heading">Ảnh</h1>
            <div class="form-group img-list">
              <ul class="m-0">
                <li v-for="(item, index) in imageData" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="item" />
                    <span @click="removeImg(index)">
                      <i class="bx bx-trash bx-sm"></i>
                    </span>
                  </a>
                </li>
                <li>
                  <div v-if="imageData.length < 5">
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div v-else class="add-img">
                      <span class="bx bx-plus text-center"></span>
                      <input type="file" ref="fileInput" @input="onSelectFile" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <b-modal id="modal-scoped" v-model="addModal">
      <template #modal-header="{ close }">
        <h5>Thêm danh mục thiết bị</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn thêm danh mục thiết bị này ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button variant="light" @click="close()"> Đóng </b-button>
        <b-button variant="primary" @click="confirmAdd"> Xác nhận </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{}">
        <h5>Thông báo</h5>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button variant="light" @click="close()" v-if="errorAdd"> Đóng </b-button>
        <b-button variant="success" @click="backToList" v-else> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="cancelModal">
      <template #modal-header="{ close }">
        <h5>Huỷ thêm danh mục thiết bị</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn huỷ ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button variant="light" @click="close()"> Đóng </b-button>
        <b-button variant="primary" @click="backToList"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { DeviceService } from '@/services/device.service'
  import { CommonService } from '@/services/common.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        loading: false,
        dataAdd: {},
        optionsType: Config.typeDevice,
        optionUnit: Config.unitDevice,
        optionService: [],
        imageData: [],
        imageDataInsert: [],
        arrayFormData: [],
        formData: new FormData(),
        loadingImage: false,
        addModal: false,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        errorAdd: false,
        cancelModal: false,
        Config,
      }
    },
    created() {
      this.getListService()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async getListService() {
        try {
          const data = await SalesManagerService.getGroupService({})
          if (data.success) {
            this.optionService = data.data.groupService
              .map(e => e.detail)
              .flat()
              .map(el => {
                return {
                  id: el.code,
                  text: el.name,
                }
              })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async addCat() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }
        this.addModal = true
      },
      async confirmAdd() {
        try {
          this.loading = true
          this.addModal = false
          this.dataAdd.images = this.imageDataInsert
          const data = await DeviceService.addCatDevice(this.dataAdd)
          if (data.success) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thêm danh mục thiết bị thành công'
          } else {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.errorAdd = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      backToList() {
        this.$router.push('/cat-device')
      },

      async onSelectFile() {
        const input = this.$refs.fileInput
        const files = input.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFomat = fomatUpload.includes(input.files[0].type)
        if (!checkFomat) {
          alert('Định dạng ảnh không đúng')
          return
        }
        this.formData = new FormData()
        this.formData.append('files', files[0])
        this.formData.append('folderName', 'NextCrm')
        this.arrayFormData.push(this.formData)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadImage()
      },

      async uploadImage() {
        try {
          this.loadingImage = true
          await CommonService.uploadImg(this.formData).then(res => {
            if (res.code === 1000) {
              this.imageDataInsert.push(res.data[0])
            }
          })
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingImage = false
        }
      },

      removeImg(index) {
        this.imageData.splice(index, 1)
        this.arrayFormData.forEach((item, i) => {
          if (index === i) {
            this.arrayFormData.splice(i, item)
          }
        })
        this.imageDataInsert.forEach((item, i) => {
          if (index === i) {
            this.imageDataInsert.splice(i, item)
          }
        })
      },
    },
  }
</script>
